import { PermissionsEnum } from '@/auth/interfaces';

export const SAVE_OPERADORA_PERMISSIONS = [
  PermissionsEnum.api_view_operadora,
];
